import { useEffect, useState } from "react";
import { Grid, Stack, Button, SvgIcon, Box } from "@mui/material";
import _ from "lodash";
import SurnameInput from "../utils/medicalDocument/form/patient/SurnameInput";
import { useForm } from "react-hook-form";
import { useApi, useIsInQuickLink, useNavigate } from "../../utils/hooks";
import TitleHeadSess from "../../utils/TitleHeadSess";
import PatientsTable from "./table-list";
import {
  PersonAddAlt1 as PatientIcon,
  Share as ShareIcon,
} from "@mui/icons-material";

const defaultPatient = { id: "", surname: "" };

const PatientPicker = ({
  setPatient,
  setAllPatients,
  allPatients,
  setLoading,
  loading,
  setPatients,
}) => {
  const form = useForm({ defaultValues: defaultPatient });
  const patient = form.watch();
  const api = useApi();

  useEffect(() => {
    api
      .patients()
      .tap(setAllPatients)
      .tap(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (patient.id && patient.surname === null) {
      form.reset();
      setPatients(allPatients);
      setPatient(defaultPatient);
      setPatients(allPatients);
    } else {
      setPatient(patient);
    }
  }, [JSON.stringify(patient)]);

  return (
    <SurnameInput
      form={form}
      patients={allPatients}
      helperText=""
      loading={loading}
      label={"Buscar pacientes"}
      noRequired={true}
    />
  );
};

const Patients = () => {
  const [patient, setPatient] = useState({});
  const [patients, setPatients] = useState([]);
  const [allPatients, setAllPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalItems, seTotalItems] = useState(0);

  const navigate = useNavigate();

  const addNew = () => {
    navigate("/patients/new", {
      state: { url: "/patients" },
    });
  };

  const addNewLink = () => {
    navigate("/patients/new/link-self-registration", {
      state: { url: "/patients" },
    });
  };

  const actions = [
    {
      variant: "contained",
      icon: <PatientIcon />,
      name: "Agregar paciente",
      action: addNew,
    },
    {
      variant: "outlined",
      icon: <ShareIcon />,
      name: "Link pacientes",
      action: addNewLink,
    },
  ];

  useEffect(() => {
    if (patient.id) {
      setPage(0);
      const searchPatient = allPatients.filter((pat) => pat.id === patient.id);
      setPatients(searchPatient);
      seTotalItems(searchPatient.length);
    } else {
      const offset = page * rowsPerPage;
      const paginatedPatients = allPatients.slice(offset, offset + rowsPerPage);
      seTotalItems(allPatients.length);
      setPatients(paginatedPatients);
    }
  }, [patient, allPatients, page, rowsPerPage]);

  const RenderButtons = () => {
    const isInQuickLink = useIsInQuickLink();
    
    if (isInQuickLink) return null;

    return actions.map(({ name, variant, icon, action }) => (
      <Button
        key={name}
        variant={variant}
        sx={{
          mr: { xs: 0, sm: 1, md: 1 },
          ml: { xs: 0, sm: 1, md: 1 },
          fontSize: { xs: 12, sm: "auto" },
        }}
        onClick={action}
      >
        <SvgIcon sx={{ fontSize: 18, mr: 0.5 }}>{icon}</SvgIcon>
        {name}
      </Button>
    ));
  }

  return (
    <Stack
      spacing="1rem"
      sx={{ p: { xs: "1rem", sm: "2rem" }, mt: { xs: "1rem" }, width: "100%" }}
    >
      <TitleHeadSess title={"Pacientes"} urlRedirect={"/"} />
      <Grid container alignItems="center">
        <Grid item xs={12} sm={12} md={6} lg={8}>
          <PatientPicker
            setPatient={setPatient}
            allPatients={allPatients}
            setAllPatients={setAllPatients}
            loading={loading}
            setLoading={setLoading}
            setPatients={setPatients}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
          container
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: { xs: "space-between", sm: "start", md: "end" },
            mt: { xs: 2, sm: 2, md: 0 },
          }}
        >
          <RenderButtons />
        </Grid>
      </Grid>
      <PatientsTable
        patients={patients}
        loading={loading}
        page={page}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        setPage={setPage}
        count={totalItems}
      />
    </Stack>
  );
};

export default Patients;
